import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "users";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports

export const userActions = { ...slice.actions, ...extraActions };
export const usersReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    users: {},
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/users`;

  return {
    getAll: getAll(),
  };

  function getAll() {
    return createAsyncThunk(
      `${name}/getAll`,
      async () => await fetchWrapper.get(baseUrl)
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.getAll.pending, (state) => {
      state.users = { loading: true };
    })
    .addCase(extraActions.getAll.fulfilled, (state, action) => {
      state.users = action.payload;
    })
    .addCase(extraActions.getAll.rejected, (state, action) => {
      state.users = { error: action.error };
    });
}
